import { Slide } from "@jelly/lesson";
import { task as task01 } from "../../../../../task/course-02/lesson-07/task-01";

const task: Slide = {
  title: `The psychoacoustic parameter “Loudness” values depend on (multiple selection possible):`,
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
